/*
 *  set better async timeout
 *
 *  param delayInMilliseconds
 *
 *  return promise
 */
import moment from "moment";
import {STATES_OPTIONS_ALL} from "./constants";

async function delay(ms) {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve(true); //
        }, ms);
    });
}

/*
 *  set callback on timeout ends
 *
 *  param delayInMilliseconds
 *  param callback
 *
 *  return promise
 */
async function onDelayEnd(ms, callback) {
    const delayres = await delay(ms);
    callback();
}

/*
 *  validate that a variable does not have a "empty" value, not usable value
 *
 *  param mixedVar
 *
 *  return promise
 */
function empty(mixedVar) {
    //  discuss at: https://locutus.io/php/empty/
    // original by: Philippe Baumann
    //    input by: Onno Marsman (https://twitter.com/onnomarsman)
    //    input by: LH
    //    input by: Stoyan Kyosev (https://www.svest.org/)
    // bugfixed by: Kevin van Zonneveld (https://kvz.io)
    // improved by: Onno Marsman (https://twitter.com/onnomarsman)
    // improved by: Francesco
    // improved by: Marc Jansen
    // improved by: Rafał Kukawski (https://blog.kukawski.pl)
    //   example 1: empty(null)
    //   returns 1: true
    //   example 2: empty(undefined)
    //   returns 2: true
    //   example 3: empty([])
    //   returns 3: true
    //   example 4: empty({})
    //   returns 4: true
    //   example 5: empty({'aFunc' : function () { alert('humpty'); } })
    //   returns 5: false

    let undef
    let key
    let i
    let len
    const emptyValues = [undef, null, false, 0, '', '0']

    for (i = 0, len = emptyValues.length; i < len; i++) {
        if (mixedVar === emptyValues[i]) {
            return true
        }
    }

    if (typeof mixedVar === 'object') {
        for (key in mixedVar) {
            if (mixedVar.hasOwnProperty(key)) {
                return false
            }
        }
        return true
    }

    return false
}

function getFormattedDate(dateValue) {
    let date = moment(dateValue);

    return date.isValid() ? date.format("L") : "";
}

function getFormattedDateTime(dateTimeValue) {
    let date = moment(dateTimeValue);

    return date.isValid() ? date.format("L LT") : "";
}

function getFormattedDateHuman(dateTimeValue) {
    let date = moment(dateTimeValue);

    return date.isValid()
        ? date.fromNow().replace(/^in /, "").replace(/^an?/, 1)
        : "";
}

function getTodayDateString() {
    return moment().format("YYYY/MM/DD");
}

function getDateDifference(dateString) {
    let date = moment(dateString),
        now = moment(),
        duration = moment.duration(date.diff(now));

    return {
        isPast: date.isBefore(now),
        days: Math.trunc(duration.asDays()),
        hours: duration.hours(),
        minutes: duration.minutes(),
    };
}

function convertFromUtc(dateValue, format = "YYYY-MM-DD HH:mm:ss") {
    return moment.utc(dateValue).local().format(format);
}

function getFormattedPrice(price) {
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
    }).format(price);
}

function getFormattedNumber(number, minDecimals = 0) {
    return new Intl.NumberFormat("en-US", {minimumFractionDigits: minDecimals}).format(number);
}

function getFormattedQty(qty, unit, separator = ' ') {
    if (unit !== 'ea') {
        qty = getFormattedNumber(qty, 2);
    }

    return `${qty}${separator}${unit}`;
}

function getFormattedStateName(stateCode) {
    let state = STATES_OPTIONS_ALL.find(state => state.value === stateCode);

    return state ? state.text : stateCode;
}

function getFormattedRecurringBilling(billing_recurrence) {
    if (billing_recurrence) {
        switch (billing_recurrence) {
            case 'week':
                return 'Weekly';
            case '2-week':
                return 'Biweekly';
            case 'month':
                return 'Monthly';
            case 'quarter':
                return 'Quarterly';
            case 'year':
                return 'Annually';
        }
    }
    return '';
}

function sortingStrFunc(first, second, ascending = true) {
    if (first < second) {
        return ascending ? -1 : 1;
    }
    if (first > second) {
        return ascending ? 1 : -1;
    }
    return 0;
}

export {
    delay,
    onDelayEnd,
    empty,
    getFormattedDate,
    getFormattedDateTime,
    getFormattedDateHuman,
    getTodayDateString,
    getDateDifference,
    convertFromUtc,
    getFormattedPrice,
    getFormattedNumber,
    getFormattedQty,
    getFormattedStateName,
    getFormattedRecurringBilling,
    sortingStrFunc
}
